export default __webpack_public_path__ + "static/media/chain-concept.a610ab26.svg";